import React from 'react';
var Button = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "red" : _b, onClick = _a.onClick, children = _a.children;
    var colorString = "bg-" + color + "-400";
    return (React.createElement("button", { className: colorString + " p-2 mr-2 rounded text-white hover:shadow-xl", onClick: onClick }, children));
};
export default Button;
